import { FormControl } from "@mui/material";
import darkColors from "assets/theme-dark/base/colors";
import borders from "assets/theme/base/borders";
import colors from "assets/theme/base/colors";
import typography from "assets/theme/base/typography";
import pxToRem from "assets/theme/functions/pxToRem";
import rgba from "assets/theme/functions/rgba";
import { useMaterialUIController } from "context";
import PropTypes from "prop-types";
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';



const { size } = typography;
const { borderRadius } = borders;


const MDSelect = ({
    theme,
    isDisabled = false,
    value,
    name,
    options,
    onChange,
    placeholder = "Selecione...",
    isMulti = false,
    creatable = false,
    ...rest }) => {
    const [controller, dispatch] = useMaterialUIController();
    const { darkMode } = controller;

    const { transparent, inputBorderColor, white, grey } = darkMode ? darkColors : colors;
    
    const SelectComponent = creatable ? CreatableSelect : Select;

    return (
        <FormControl fullWidth>
            <SelectComponent
                {...rest}
                closeMenuOnSelect={true}
                name={name}
                value={value}
                options={options}
                onChange={onChange}
                isDisabled={isDisabled}
                placeholder={placeholder}
                isMulti={isMulti}
                noOptionsMessage={() => "Nenhuma opção"}
                loadingMessage={() => "Carregando..."}
                menuPortalTarget={document.body} // <-- aqui é o segredo
                styles={{
                    control: (styles, state) => {
                        const disabledBg = darkMode ? grey[800] : grey[200];
                        const disabledText = darkMode ? white.main : grey[600];
                        const disabledBorder = darkMode ? grey[700] : grey[300];

                        return {
                            ...styles,
                            backgroundColor: state.isDisabled ? disabledBg : transparent.main,
                            color: state.isDisabled ? disabledText : (darkMode ? white.main : grey[800]),
                            borderColor: state.isDisabled ? disabledBorder : rgba(inputBorderColor, darkMode ? 0.6 : 1),
                            opacity: 1,
                            pointerEvents: state.isDisabled ? "none" : "auto",
                            fontSize: size.xs,
                            minHeight: pxToRem(30),
                            height: 'auto',
                            paddingTop: 0,
                            paddingBottom: 0,
                            borderRadius: borderRadius.md,
                        };
                    },
                    singleValue: (styles) => ({
                        ...styles,
                        color: darkMode ? "#FFFFFF !important" : grey[800],
                    }),
                    placeholder: (styles) => ({
                        ...styles,
                        color: darkMode ? "rgba(255, 255, 255, 0.6) !important" : grey[600],
                    }),
                    input: (styles) => ({
                        ...styles,
                        color: darkMode ? "#FFFFFF !important" : grey[800],
                        padding: 0,
                        margin: 0,
                    }),
                    multiValue: (styles) => ({
                        ...styles,
                        backgroundColor: darkMode ? '#5A6072' : '#e0e0e0',
                        borderRadius: '4px',
                    }),
                    multiValueLabel: (styles) => ({
                        ...styles,
                        color: darkMode ? '#FFFFFF !important' : '#333333',
                        fontSize: '11px',
                        padding: '2px 6px',
                    }),
                    multiValueRemove: (styles) => ({
                        ...styles,
                        color: darkMode ? '#FFFFFF !important' : '#333333',
                        '&:hover': {
                            backgroundColor: darkMode ? '#707582' : '#d0d0d0',
                            color: '#ff4d4f',
                        },
                    }),
                    option: (styles, { isDisabled, isFocused, isSelected }) => {
                        return {
                            ...styles,
                            fontSize: size.xs,
                            cursor: isDisabled ? 'not-allowed' : 'pointer',
                            color: isSelected 
                                ? '#ffffff !important' 
                                : (darkMode ? '#FFFFFF !important' : grey[800]),
                            backgroundColor: isSelected 
                                ? '#1A73E8 !important' 
                                : isFocused 
                                ? (darkMode ? '#545866 !important' : '#e3f2fd !important') 
                                : (darkMode ? '#383C48 !important' : '#ffffff !important'),
                            padding: `${pxToRem(8)} ${pxToRem(12)}`,
                            '&:active': {
                                backgroundColor: isSelected ? '#1A73E8 !important' : '#bbdefb !important'
                            }
                        };
                    },
                    valueContainer: (styles) => ({
                        ...styles,
                        padding: `0 ${pxToRem(8)}`,
                    }),
                    dropdownIndicator: (styles) => ({
                        ...styles,
                        padding: pxToRem(4),
                        color: darkMode ? "rgba(255, 255, 255, 0.8) !important" : undefined,
                    }),
                    clearIndicator: (styles) => ({
                        ...styles,
                        padding: pxToRem(4),
                        color: darkMode ? "rgba(255, 255, 255, 0.8) !important" : undefined,
                    }),
                    menu: (styles) => ({
                        ...styles,
                        backgroundColor: darkMode ? "#383C48 !important" : "#ffffff !important",
                        border: darkMode ? "1px solid #606472" : "1px solid #e0e0e0",
                        boxShadow: "0 8px 24px rgba(0, 0, 0, 0.45)",
                        zIndex: 99999,
                    }),
                    menuList: (styles) => ({
                        ...styles,
                        backgroundColor: darkMode ? "#383C48 !important" : "#ffffff !important",
                        padding: 0,
                    }),
                    menuPortal: (base) => ({
                        ...base,
                        zIndex: 99999,
                    }),
                }}
            />
        </FormControl>

    )
};

MDSelect.propTypes = {
    isDisabled: PropTypes.bool,
    name: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    isMulti: PropTypes.bool
};

export default MDSelect
